import {SET_ERRORS,CLEAR_ERRORS, SET_AREAS, LOADING_DATA_INF, SET_OK, LOADING_UI, SET_AREA, SET_PROGMTOS_INFRA, LOADING_DATA_MTO_INFRA, SET_MTOS_INFRA, SET_MTO_INFRA, SET_CORRECTIVOS_INFRA, SET_CORRECTIVO_INFRA, SET_SOLICITUDESCORR_INFRA, POST_MTOCORRECTIVO_INFRA} from '../types';
import axios from 'axios'; 
import { apiV1, apiV2, setAuthorizationHeader } from '../../utils/api';
export const getAreas =(clienteId)=>dispatch=>{
    dispatch({type:LOADING_DATA_INF});
    apiV1.get(`/getAreas/${clienteId}`)
    .then(res=>{
        dispatch({
            type:SET_AREAS,
            payload:res.data
        });
        dispatch(clearErrors());
    }).catch(err=>{
        dispatch({
            type: SET_ERRORS,
            payload:[]
        });
    })
    
}

export const postArea=(newArea, clienteId)=>dispatch=>{
    dispatch({type:LOADING_UI});
    apiV1
    .post(`/creararea/${clienteId}`,newArea,)
    .then((res)=>{
        dispatch({
            type:SET_OK,
            payload:res.data
        });
        dispatch(clearErrors());      

      
        
              
    })
    .catch((err)=>{
        dispatch({
            type: SET_ERRORS,
            payload: err.response.data
          });
    });

};

export const subirImagenArea=(formData,areaId,clienteId)=> (dispatch)=>{
    dispatch({type:LOADING_UI});
    
    apiV1.post(`/subirimagenarea/${areaId}`,formData)
    .then(()=>{
      dispatch(getAreas(clienteId));
    })
    .catch(err=>console.log(err)); 
  };

  export const getArea =(areaId,clienteId)=>dispatch=>{
    dispatch({type:LOADING_DATA_INF});
    apiV1.get(`/getarea/${areaId}/${clienteId}`)
    .then(res=>{
        dispatch({
            type:SET_AREA,
            payload:res.data
        });
        dispatch(clearErrors());
    }).catch(err=>{
        dispatch({
            type: SET_ERRORS,
            payload:[]
        });
    })
}

export const editArea=(newArea, areaId)=>dispatch=>{
    dispatch({type:LOADING_UI});
    apiV1
    .post(`/editarea/${areaId}`,newArea,)
    .then((res)=>{
        dispatch({
            type:SET_OK,
            payload:res.data
        });
        dispatch(clearErrors());      

      
        
              
    })
    .catch((err)=>{
        dispatch({
            type: SET_ERRORS,
            payload: err.response.data
          });
    });

};

export const progMtoInfra=(newpmto,areaId)=>dispatch=>{
    dispatch({type:LOADING_UI});
    apiV1
    .post(`/progmtoinfra/${areaId}`,newpmto)
    .then((res)=>{
        dispatch({
            type:SET_OK,
            payload:res.data
        });
        dispatch(clearErrors());

     
        
    })
    .catch((err)=>{
        dispatch({
            type: SET_ERRORS,
            payload: err.response.data
          });
    });

};

export const progMtoAutoInfra=(newpmto,clienteId)=>dispatch=>{
    dispatch({type:LOADING_UI});
    apiV1
    .post(`/cronogramamtoautoinfra/${clienteId}`,newpmto)
    .then((res)=>{
        dispatch({
            type:SET_OK,
            payload:res.data
        });
        dispatch(clearErrors());

     
        
    })
    .catch((err)=>{
        dispatch({
            type: SET_ERRORS,
            payload: err.response.data
          });
    });

};


export const cambiarEstadoArea=(areaId,nuevoEstado)=>dispatch=>{
    dispatch({type:LOADING_UI});
    apiV1
    .post(`/cambiarestado/${areaId}/${nuevoEstado}`)
    .then((res)=>{
        dispatch({
            type:SET_OK,
            payload:res.data
        });
        dispatch(clearErrors());

     
        
    })
    .catch((err)=>{
        dispatch({
            type: SET_ERRORS,
            payload: err.response.data
          });
    });

};

export const getProgMtosInfra =(areaId)=>dispatch=>{
    dispatch({type:LOADING_DATA_MTO_INFRA});
    apiV1.get(`/getprogmtosinfra/${areaId}`)
    .then(res=>{
        dispatch({
            type:SET_PROGMTOS_INFRA,
            payload:res.data
        });
        dispatch(clearErrors());
    }).catch(err=>{
        dispatch({
            type: SET_ERRORS,
            payload:[]
        });
    })
    
}

export const getProgMtosInfraCliente =(clienteId)=>dispatch=>{
    dispatch({type:LOADING_DATA_MTO_INFRA});
    apiV1.get(`/getprogmtosinfracliente/${clienteId}`)
    .then(res=>{
        dispatch({
            type:SET_PROGMTOS_INFRA,
            payload:res.data
        });
        dispatch(clearErrors());
    }).catch(err=>{
        dispatch({
            type: SET_ERRORS,
            payload:[]
        });
    })
    
}

export const getProgMtosInfraClienteFiltrado = (clienteId, fechaInicio, fechaFin) => dispatch => {
    
    apiV1.get(`/getListaMtosInfraClienteFiltrado/${clienteId}`, {
      params: {
        fechaInicio: fechaInicio,
        fechaFin: fechaFin
      }
    })
      .then(res => {
        dispatch({
          type: SET_PROGMTOS_INFRA,
          payload: res.data
        });
        dispatch(clearErrors());
      }).catch(err => {
        dispatch({
          type: SET_ERRORS,
          payload: err.response.data
        });
        console.log(err.response.data)
      })
  }
  
  function dataURItoBlob(dataURI) {
    let byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
      byteString = atob(dataURI.split(',')[1]); // decodifica base64
    } else {
      byteString = unescape(dataURI.split(',')[1]); // decodifica URL
    }
  
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
  
    return new Blob([ia], { type: mimeString });
  }
/**
 * Action creator para postear mantenimiento de infraestructura.
 * Si metodoRecepcion es 'firma' o 'imagen', se envía como multipart/form-data
 * para que Busboy lo parsee correctamente.
 */
export const postMtoInfra = (newpmto, areaId, clienteid, handleuser, progid) => (dispatch) => {
    dispatch({ type: LOADING_UI });
  
    // Verificar si debemos usar FormData (cuando haya firma/imágen)
    const usarFormData = 
      newpmto.metodoRecepcion === 'firma' || 
      newpmto.metodoRecepcion === 'imagen';
  
    let requestData;
    let headers = {};
  
    if (usarFormData) {
      // Construimos el FormData
      requestData = new FormData();
  
      Object.keys(newpmto).forEach((key) => {
        if ((key === 'firmaDigital' || key === 'imagenFirma') && newpmto[key]) {
          // Tenemos un string base64 que representa una imagen
          if (newpmto[key].startsWith('data:image')) {
            const imageBlob = dataURItoBlob(newpmto[key]);
            // El nombre del archivo puede ser 'firma.png' o lo que gustes
            const fileName = (key === 'firmaDigital') ? 'firma.png' : 'imagen.png';
            // Subimos el archivo al campo 'file' (o ponle otro nombre si gustas)
            requestData.append('file', imageBlob, fileName);
          }
        } else {
          // Campos normales (text, number, etc.)
          requestData.append(key, newpmto[key]);
        }
      });
  
      // NO seteamos manualmente 'Content-Type'; el navegador lo hace
    } else {
      // Si no hay firma ni imagen, enviamos JSON
      requestData = newpmto;
      headers['Content-Type'] = 'application/json';
    }
  
    // Llamar a la ruta de tu backend con axios
    apiV2
      .post(
        `/postmtoinfra/${clienteid}/${areaId}/${handleuser}/${progid}`,
        requestData,
        { headers }
      )
      .then((res) => {
        dispatch({
          type: SET_OK,
          payload: res.data
        });
        dispatch({ type: CLEAR_ERRORS });
      })
      .catch((err) => {
        dispatch({
          type: SET_ERRORS,
          payload: err.response ? err.response.data : { error: 'Error al procesar la solicitud' }
        });
      });
  };

export const deleteProgMtoInfra =(progId)=>(dispatch)=>{
    dispatch({type:LOADING_UI});
   
    apiV1
    .post(`/deleteprogmtoinfra/${progId}`)
    .then((res) => {
        dispatch({
            type:SET_OK,
            payload:res.data
        });
      
        
    })
    .catch((err) => console.log(err));
}



export const getMtosInfra =(areaId)=>dispatch=>{
    dispatch({type:LOADING_DATA_MTO_INFRA});
    apiV1.get(`/getmtosinfra/${areaId}`)
    .then(res=>{
        dispatch({
            type:SET_MTOS_INFRA,
            payload:res.data
        });
        dispatch(clearErrors());
    }).catch(err=>{
        dispatch({
            type: SET_ERRORS,
            payload:[]
        });
    })
    
}

export const getMtoInfra =(areaId,clienteId,mtoId)=>dispatch=>{
    dispatch({type:LOADING_DATA_MTO_INFRA});
    apiV2.get(`/getmtoinfra/${areaId}/${clienteId}/${mtoId}`)
    .then(res=>{
        dispatch({
            type:SET_MTO_INFRA,
            payload:res.data
        });
        dispatch(clearErrors());
    }).catch(err=>{
        dispatch({
            type: SET_ERRORS,
            payload:[]
        });
    })
    
}

export const deleteMtoInfra =(mtoId,progId)=>(dispatch)=>{
    dispatch({type:LOADING_UI});
   
    apiV1
    .post(`/deletemtoinfra/${mtoId}/${progId}`)
    .then((res) => {
        dispatch({
            type:SET_OK,
            payload:res.data
        });
      
        
    })
    .catch((err) => console.log(err));
}

export const postCorrectivoInfra=(newpmto,areaId,clienteid,handleuser)=>dispatch=>{
    ///postmtoinfra/:clienteid/:areaid/:handleuser/:progid
    dispatch({type:LOADING_UI});
    apiV1
    .post(`/postcorrinfra/${clienteid}/${areaId}/${handleuser}`,newpmto)
    .then((res)=>{
        dispatch({
            type:SET_OK,
            payload:res.data
        });
        dispatch(clearErrors());

     
        
    })
    .catch((err)=>{
        dispatch({
            type: SET_ERRORS,
            payload: err.response.data
          });
    });

};

export const postMtoCorrectivoInfraV2 = (newmtocorr, areaid, clienteid, handleuser,solicitudid) => (dispatch) => {
  dispatch({type: LOADING_UI});
  
  // Comprobar si tenemos una firma digital o imagen que enviar
  if (newmtocorr.metodoRecepcion === 'firma' || newmtocorr.metodoRecepcion === 'imagen') {
      // Crear un objeto FormData para enviar archivos
      const formData = new FormData();
      
      // Agregar todos los campos del objeto newmtocorr al FormData
      Object.keys(newmtocorr).forEach(key => {
          // Ignorar el campo de imagen por ahora
          if (key !== 'imagenFirma') {
              // Para valores booleanos, convertirlos a cadenas
              if (typeof newmtocorr[key] === 'boolean') {
                  formData.append(key, newmtocorr[key].toString());
              } else {
                  formData.append(key, newmtocorr[key]);
              }
          }
      });
      
      // Convertir la cadena base64 a Blob y agregarla como archivo
      if (newmtocorr.imagenFirma) {
          // Extraer la parte de datos de la URL de datos
          const base64Data = newmtocorr.imagenFirma.split(',')[1];
          const blob = b64toBlobInfra(base64Data, 'image/png');
          formData.append('file', blob, 'firma.png');
      }
      
      // Luego, enviar el FormData
      apiV2.post(`/postcorrinfra/${clienteid}/${areaid}/${handleuser}/${solicitudid}`, formData, {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      })
      .then((res) => {
          dispatch({
              type: POST_MTOCORRECTIVO_INFRA,
              payload: res.data
          });
          dispatch({
              type: SET_OK,
              payload: {
                  mensaje: 'Solicitud enviada exitosamente'
              }
          });
          dispatch(clearErrors());
      })
      .catch((err) => {
          dispatch({
              type: SET_ERRORS,
              payload: err.response.data
          });
      });
  } else {
      // Para métodos sin imágenes, hacer una solicitud JSON regular
      apiV2.post(`/postcorrinfra/${clienteid}/${areaid}/${handleuser}/${solicitudid}`, newmtocorr)
      .then((res) => {
          dispatch({
              type: POST_MTOCORRECTIVO_INFRA,
              payload: res.data
          });
          dispatch({
              type: SET_OK,
              payload: {
                  mensaje: 'Solicitud enviada exitosamente'
              }
          });
          dispatch(clearErrors());
      })
      .catch((err) => {
          dispatch({
              type: SET_ERRORS,
              payload: err.response.data
          });
      });
  }
};

// Función auxiliar para convertir base64 a Blob
function b64toBlobInfra(b64Data, contentType = '', sliceSize = 512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      
      for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
      }
      
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {type: contentType});
  return blob;
}


  

export const getMtosCorrectivosInfra =(areaId)=>dispatch=>{
    dispatch({type:LOADING_DATA_MTO_INFRA});
    apiV2.get(`/getcorrectivosinfra/${areaId}`)
    .then(res=>{
        dispatch({
            type:SET_CORRECTIVOS_INFRA,
            payload:res.data
        });
        dispatch(clearErrors());
    }).catch(err=>{
        dispatch({
            type: SET_ERRORS,
            payload:[]
        });
    })
    
}

export const getCorrInfra =(areaId,clienteId,solicitudId)=>dispatch=>{
    dispatch({type:LOADING_DATA_MTO_INFRA});
    apiV2.get(`/getcorrectivoinfra/${areaId}/${clienteId}/${solicitudId}`)
    .then(res=>{
        dispatch({
            type:SET_CORRECTIVO_INFRA,
            payload:res.data
        });
        dispatch(clearErrors());
    }).catch(err=>{
        dispatch({
            type: SET_ERRORS,
            payload:[]
        });
    })
    
}

export const deleteCorrInfra =(mtoId,progId)=>(dispatch)=>{
    dispatch({type:LOADING_UI});
   
    apiV1
    .post(`/deletecorrectivoinfra/${mtoId}/${progId}`)
    .then((res) => {
        dispatch({
            type:SET_OK,
            payload:res.data
        });
      
        
    })
    .catch((err) => console.log(err));
}
export const subirEvidenciaMtoCorrInfra = (formData, mtoid) => (dispatch) => {
    dispatch({ type: LOADING_UI });
    apiV1.post(`/subirevidenciamtocorrinfra/${mtoid}`, formData)
      .then((res) => {
        dispatch({
          type: SET_OK,
          payload: res.data
        })
        dispatch(clearErrors());
     
      })
      .catch(err => console.log(err));
  };
export const clearErrors = () => (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
  };


  export const postSolicitudMtoInfra=(newsolicitud,areaId)=>dispatch=>{
    ///postmtoinfra/:clienteid/:areaid/:handleuser/:progid
    dispatch({type:LOADING_UI});
    apiV2
    .post(`/solicitarmtoinfra/${areaId}`,newsolicitud)
    .then((res)=>{
        dispatch({
            type:SET_OK,
            payload:res.data
        });
        dispatch(clearErrors());

     
        
    })
    .catch((err)=>{
        dispatch({
            type: SET_ERRORS,
            payload: err.response.data
          });
    });

};

export const getSolicitudesCorrInfra =(areaId)=>dispatch=>{
    dispatch({type:LOADING_DATA_MTO_INFRA});
    apiV2.get(`/getsolicitudesinfra/${areaId}`)
    .then(res=>{
        dispatch({
            type:SET_SOLICITUDESCORR_INFRA,
            payload:res.data
        });
        dispatch(clearErrors());
    }).catch(err=>{
        dispatch({
            type: SET_ERRORS,
            payload:[]
        });
    })
    
}


export const getSolicitudesInfraClienteFiltrado = (clienteId, fechaInicio, fechaFin) => dispatch => {
    dispatch({ type: LOADING_DATA_MTO_INFRA });
    apiV2.get(`/getsolicitudesinfrafiltrado/${clienteId}`, {
      params: {
        fechaInicio: fechaInicio,
        fechaFin: fechaFin
      }
    })
      .then(res => {
        dispatch({
        type:SET_SOLICITUDESCORR_INFRA,
          payload: res.data
        });
        dispatch(clearErrors());
      }).catch(err => console.log(err))
  }

export const subirEvidenciaSolCorrInfra = (formData, solicitudid) => (dispatch) => {
    dispatch({ type: LOADING_UI });
    apiV1.post(`/subirevidenciasolicitudinfra/${solicitudid}`, formData)
      .then((res) => {
        dispatch({
          type: SET_OK,
          payload: res.data
        })
        dispatch(clearErrors());
     
      })
      .catch(err => console.log(err));
  };

  export const postAprobarMtoInfraAsis=(mtoid)=>(dispatch)=>{
    dispatch({type:LOADING_UI})

    apiV1.post(`/aprobarmtoinfra/${mtoid}`)
    .then((res)=>{
        dispatch({
            type:SET_OK,
            payload:res.data
        });

    })
    .catch((err)=>{
        dispatch({
            type: SET_ERRORS,
            payload: err.response.data
          });
    });
}
